module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAuklEQVQ4jZXUIRaCQBDG8T+rj2KBotlTeBGDpE0ewVOYrFokUbyIR/AKFigWylqAh7LLzkzamfd+M1/aJDvcU2AHPOvKtgjKACvgBDzyokylqAGOXS+Cpq6sA94aaAC00PQPDTTjRgrN/0ACJ0gCvSgGE+dcyAGQF2UCrIFbN9pH0QhugOtsPE8N26PIF28W+UBd2TaIQiAYbw54UQxMkAT8ICkYkAYALC6vrQr0lzINAFgCH+CM4gv7AnOXcvsfnK7nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_jt_r_hover.png
// module id = tXkp
// module chunks = 0